if (!customElements.get('section-featured-collection')) {
  class TG_SectionFeauredCollection extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      var _this = this;

      this.delegateElement = new ebbflow.libs.Delegate(this);
      this.options = JSON.parse(this.getAttribute('data-section-settings'));

      this.carousels = [];

      ebbflow.helpers.Dom.nodeListToArray(this.querySelectorAll('[data-carousel-config]')).forEach(function (item) {
          _this.carousels.push(new ebbflow.components.Carousel(item));
      });

      if (this.options['layout'] === 'grid' && this.options['animationType'] === 'staggering') {
        this._setupAnimation();
      }
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      if(this.intersectionObserver)this.intersectionObserver.disconnect();
      if(this.carousels){
        this.carousels.forEach(function (carousel) {
          carousel.destroy();
        });
      }
    }

    _setupAnimation() {
      var _this = this;
          
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
  
      if (this.options['layout'] === 'grid') {
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
  
        ebbflow.helpers.Dom.nodeListToArray(this.querySelectorAll('.ProductList--grid .ProductCard')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      } 
    }
    
    _reveal(results) {
      var _this = this;
  
      var toReveal = [];
  
      results.forEach(function (result) {
        if (result.isIntersecting || result.intersectionRatio > 0) {
          toReveal.push(result.target);
          _this.intersectionObserver.unobserve(result.target);
        }
      });
  
      if (toReveal.length === 0) {
        return;
      }
  
      ebbflow.libs.anime({
        targets: toReveal,
        opacity: [0, 1],
        translateY: [30,0],
        delay: 500,
        duration: 500,
        easing: 'cubicBezier(.5, .05, .1, .3)',
        delay: ebbflow.libs.anime.stagger(300)
      });    
    }
    
  }
        
  customElements.define('section-featured-collection', TG_SectionFeauredCollection);
}